<app-header></app-header>

<div class="inside">
    <div class="row">

      <div class="col-sm">
        <h4 class="height">Montag</h4>
        <ul class="col-sm-12  offset-sm-12">
          <div *ngFor="let item of  orderedItems">
            <div *ngIf="item.day === 'monday'">
              <mat-card class="example-card" [ngStyle]="{backgroundColor: item.bgColor}" (click)="openDialog(item)">
                <div class="middle" matBadge="{{ item.likers && (item.likers.length === item.capacity) ? item.likers.length : null }}" matBadgeOverlap="true"></div>
                <mat-card-header>
                  <mat-card-title class="insideText">{{ item.course }}</mat-card-title>
                  <mat-card-subtitle class="insideText">{{ item.starttime }} - {{ item.endtime }}</mat-card-subtitle>
                  <mat-card-footer
                    *ngIf="item.likers.includes(user.email)"
                    class="signed">
                    Du nimmst teil
                  </mat-card-footer>
                </mat-card-header>
              </mat-card>
            </div>
          </div>
        </ul>
      </div>

      <div class="col-sm">
        <h4 class="height">Dienstag</h4>
        <ul class="col-sm-12  offset-sm-12">
          <div *ngFor="let item of orderedItems">
            <div *ngIf="item.day === 'tuesday'">
              <mat-card class="example-card" [ngStyle]="{backgroundColor: item.bgColor}" (click)="openDialog(item)">
                <div class="middle" matBadge="{{ item.likers && (item.likers.length === item.capacity) ? item.likers.length : null }}" matBadgeOverlap="true"></div>
                <mat-card-header>
                  <mat-card-title class="insideText">{{ item.course }}</mat-card-title>
                  <mat-card-subtitle class="insideText">{{ item.starttime }} - {{ item.endtime }}</mat-card-subtitle>
                  <mat-card-footer
                    *ngIf="item.likers.includes(user.email)"
                    class="signed">
                    Du nimmst teil
                  </mat-card-footer>
                </mat-card-header>
              </mat-card>
            </div>
          </div>
        </ul>
      </div>

      <div class="col-sm">
        <h4 class="height">Mittwoch</h4>
        <ul class="col-sm-12  offset-sm-12">
          <div *ngFor="let item of orderedItems">
            <div *ngIf="item.day === 'wednesday'">
              <mat-card class="example-card" [ngStyle]="{backgroundColor: item.bgColor}" (click)="openDialog(item)">
                <div class="middle" matBadge="{{ item.likers && (item.likers.length === item.capacity) ? item.likers.length : null }}" matBadgeOverlap="true"></div>
                <mat-card-header>
                  <mat-card-title class="insideText">{{ item.course }}</mat-card-title>
                  <mat-card-subtitle class="insideText">{{ item.starttime }} - {{ item.endtime }}</mat-card-subtitle>
                </mat-card-header>
                <mat-card-footer
                  *ngIf="item.likers.includes(user.email)"
                  class="signed">
                  Du nimmst teil
                </mat-card-footer>
              </mat-card>
            </div>
          </div>
        </ul>
      </div>

      <div class="col-sm">
        <h4 class="height">Donnerstag</h4>
        <ul class="col-sm-12  offset-sm-12">
          <div *ngFor="let item of orderedItems">
            <div *ngIf="item.day === 'thursday'">
              <mat-card class="example-card" [ngStyle]="{backgroundColor: item.bgColor}" (click)="openDialog(item)">
                <div class="middle" matBadge="{{ item.likers && (item.likers.length === item.capacity) ? item.likers.length : null }}" matBadgeOverlap="true"></div>
                <mat-card-header>
                  <mat-card-title class="insideText"> {{ item.course }}</mat-card-title>
                  <mat-card-subtitle class="insideText">{{ item.starttime }} - {{ item.endtime }}</mat-card-subtitle>
                  <mat-card-footer
                    *ngIf="item.likers.includes(user.email)"
                    class="signed">
                    Du nimmst teil
                  </mat-card-footer>
                </mat-card-header>
              </mat-card>
            </div>
          </div>
        </ul>
      </div>

      <div class="col-sm">
        <h4 class="height">Freitag</h4>
        <ul class="col-sm-12  offset-sm-12">
          <div *ngFor="let item of orderedItems">
            <div *ngIf="item.day === 'friday'">
              <mat-card class="example-card" [ngStyle]="{backgroundColor: item.bgColor}" (click)="openDialog(item)">
                <div class="middle" matBadge="{{ item.likers && (item.likers.length === item.capacity) ? item.likers.length : null }}" matBadgeOverlap="true"></div>
                <mat-card-header>
                  <mat-card-title class="insideText">{{ item.course }}</mat-card-title>
                  <mat-card-subtitle class="insideText">{{ item.starttime }} - {{ item.endtime }}</mat-card-subtitle>
                  <mat-card-footer
                    *ngIf="item.likers.includes(user.email)"
                    class="signed">
                    Du nimmst teil
                  </mat-card-footer>
                </mat-card-header>
              </mat-card>
            </div>
          </div>
        </ul>
      </div>

      <div class="col-sm">
        <h4 class="height">Samstag</h4>
        <ul class="col-sm-12  offset-sm-12">
          <div *ngFor="let item of orderedItems">
            <div *ngIf="item.day === 'saturday'">
              <mat-card class="example-card" [ngStyle]="{backgroundColor: item.bgColor}" (click)="openDialog(item)">
                <div class="middle" matBadge="{{ item.likers && (item.likers.length === item.capacity) ? item.likers.length : null }}" matBadgeOverlap="true"></div>
                <mat-card-header>
                  <mat-card-title class="insideText"> {{ item.course }}</mat-card-title>
                  <mat-card-subtitle class="insideText">{{ item.starttime }} - {{ item.endtime }}</mat-card-subtitle>
                  <mat-card-footer
                    *ngIf="item.likers.includes(user.email)"
                    class="signed">
                    Du nimmst teil
                  </mat-card-footer>
                </mat-card-header>
              </mat-card>
            </div>
          </div>
        </ul>
      </div>

      <div class="col-sm">
        <h4 class="height">Sonntag</h4>
        <ul class="col-sm-12  offset-sm-12">
          <div *ngFor="let item of orderedItems">
            <div *ngIf="item.day === 'sunday'">
              <mat-card class="example-card" [ngStyle]="{backgroundColor: item.bgColor}" (click)="openDialog(item)">
                <div class="middle" matBadge="{{ item.likers && (item.likers.length === item.capacity) ? item.likers.length : null }}" matBadgeOverlap="true"></div>
                <mat-card-header>
                  <mat-card-title class="insideText"> {{ item.course }}</mat-card-title>
                  <mat-card-subtitle class="insideText">{{ item.starttime }} - {{ item.endtime }}</mat-card-subtitle>
                  <mat-card-footer
                    *ngIf="item.likers.includes(user.email)"
                    class="signed">
                    Du nimmst teil
                  </mat-card-footer>
                </mat-card-header>
              </mat-card>
            </div>
          </div>
        </ul>
      </div>


    </div>
</div>

<router-outlet></router-outlet>
